import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import StyledZeroState from './StyledZeroState';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoSearchResults = () => {
  const {
    clearAllFilterValuesAndSearch
  } = useFilterValues();
  return /*#__PURE__*/_jsxs(StyledZeroState, {
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "empty-state-charts",
      width: "200px"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h2",
      color: "icon-core-subtle",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.noSearchResults.title"
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-200",
      color: "icon-core-subtle",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.noSearchResults.body"
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "tertiary-light",
      onClick: clearAllFilterValuesAndSearch,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.noSearchResults.button"
      })
    })]
  });
};
NoSearchResults.displayName = 'NoSearchResults';
export default NoSearchResults;